'use strict';/* global define:false */define('modules/core/modules/app/directives/app-state/index',['require'],function(require){'use strict';// @ngInject
directive.$inject = ["appState"];
function directive(appState){return{restrict:'A',link:function link(scope,element,attrs){// jshint latedef:false
appState.set(attrs.appState);scope.$watch(appState.get,setState);// ---
function setState(value){attrs.$set('appState',value);}}};}return directive;});
